module.exports = __webpack_public_path__ + "img/price-down-title_2.374d77d5.png";